<template>
	<section class="summer-module">
		<div class="summer-wrapper">     
			<!-- <div class="summer-title for-desktop"><img src="./../assets/summer/summer_title.png" alt="here for you this summer only"></div>
			<div class="summer-title for-mobile"><img src="./../assets/summer/summer_title-m.png" alt="here for you this summer only"></div> -->
			<h3>we're back</h3>
			    <div class="carousel-overlay2" v-bind:class="{ open: modalOpen }" v-on:click="closeModal">
				<div class="carousel-modal2" v-on:click="stopPropagation" v-bind:class="{ fadeIn: modalOpen }">
					<div class="carousel-modal2--close" v-on:click="closeModal">
					<icon name="times" v-on:click="closeModal"></icon>
					</div>
					<p>Buy Now</p>
					<a href="https://www.amazon.com/stores/page/62552148-60F1-4F83-96DE-6D4E02473C35?channel=bubly_com" target="blank"><img src="./../assets/amazon.png" alt="Buy on Amazon" /></a>
					<a href="https://www.walmart.com/ip/bubly-Summer-Variety-Pack-Strawberry-Pineapple-Watermelon-12-oz-Cans-18-Count/763355897" target="blank"><img src="./../assets/walmart.png" alt="Buy on Walmart.com" /></a>
				</div>
				</div>

			<div class="summer-ctas-alt"><a class="buyCta-alt">buy now</a></div>
			<div class="summer-cans for-desktop"><img src="./../assets/summer/summer_cans.png" alt="pineapple bubly | watermelon bubly"></div>
		</div>
	</section>
</template>





<script>
 	import Icon from 'vue-awesome/components/Icon';
	export default {
		name: 'summer',
		components: {
			Icon
		},
		    mounted(){
				const ctas = document.querySelector('.buyCta-alt');
				ctas.addEventListener('click', this.showModal);
			},
		data() {
			return {
				modalOpen: false
			}
		},
		methods: {
			showModal(e){
				e.preventDefault();
				this.modalOpen = true;
				console.log(this)
			},
			closeModal(e){
				e.stopPropagation();
				this.modalOpen = false;
			},
			 stopPropagation(e){
				console.log('stop prop');
			},
		}
	};
</script>





<style lang='scss' scoped>
@import './../variables';
//$bubble-radius: 120px;
//$bubble-radius-desktop: 174px;

.summer-module {
	position: relative;
	//overflow: hidden;
	min-height: 500px;
	background-image: url(./../assets/summer/summer_bg-m.gif);
	background-size: cover;
	background-repeat:no-repeat;
	background-position: center;
}

.summer-wrapper {width:100%; height:100%;}

.summer-title {
	position: relative;
	max-width: 800px;
	padding-left:15px;
	padding-right:15px;
	height: auto;
	margin: 0 auto;
}

h3 {
	height: 170px;
    text-align: center;
    font-size: 5rem;
    margin: 3rem 0 0 -2rem;
	display: inline-block;
	max-width: 86%;
}

.summer-cans {
	position: relative;
	max-width: 800px;
	padding-left:15px;
	padding-right:15px;
	height: auto;
	margin: 0 auto;
}

.summer-title img,.summer-cans img {width: 100%; height: auto;}

.for-mobile {display:block;}
.for-desktop {display:none;}

@media (min-width:767px){
	.for-mobile {display:none;}
	.for-desktop {display:block;}
	.summer-module {
		// background: rgb(245,205,0);
		// background: linear-gradient(90deg, rgba(245,205,0,1) 50%, rgba(97,190,162,1) 50%);
		background-image: url(./../assets/summer/summer_bg.gif) ,linear-gradient(90deg, rgba(245,205,0,1) 50%, rgba(97,190,162,1) 50%) ;
	}
	
	h3 {
		font-size: 8rem;
		margin-left: -4rem;
	}
}

.summer-ctas-alt {
	display:block;
	text-align:center;
	padding: 0 20px;
	margin-bottom:40px;
	box-sizing: border-box;
	a {
		box-sizing: border-box;
		width: 50%;
		margin: 0 auto;
		padding: 5px;
		text-align: center;
		border: 2px solid #fff;
		border-radius: 20px;
		display: inline-block;
		font-size: 18px;
		color:#fff;
		padding: 7px;
		cursor: pointer;
		background-color:transparent;
		
		&:hover {
			background-color: #fff;
			border: 2px solid #fff;
			color:#1ead8a;
		}
	}
}

@include breakpoint('tablet') {
	.summer-ctas-alt {
		padding: 0;
		margin:o;
		a {
			width: auto;
			margin-left: 0;
			padding-left: 20px;
			padding-right: 20px;
		}
	}
}

@include breakpoint('desktop') {
	.summer-ctas-alt {
		margin-top: 0;
		margin-bottom: 20px;
	}
}

.carousel-overlay2 {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background: rgba(0,0,0,.7);
    align-items: center;
    justify-content: center;

    &.open {
      display: block;
    }
}

.carousel-modal2 {
    width: 100%;
    height: auto;
    min-height: 340px;
    background: #FFF;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
    padding: 90px 50px 70px;
    color: #000;
    opacity: 0;

    @include breakpoint('tablet') {
      width: 25rem;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &--close {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 24px;
      padding: 10px;
      cursor: pointer;
    }
    a {
      display: block;
      margin: 1.5rem auto;
    }
    p {
      position: absolute;
      top: 11px;
      left: 50%;
      transform: translateX(-50%);
      text-transform: lowercase;
      font-weight: 600;
      font-size: 16px;
    }
  }

    @-webkit-keyframes fadeIntro { from { opacity:0; } to { opacity:1; } }
  	@-moz-keyframes fadeIntro { from { opacity:0; } to { opacity:1; } }
  	@keyframes fadeIntro { from { opacity:0; } to { opacity:1; } }

    .fadeIn {
		opacity:0;  /* make things invisible upon start */
		animation:fadeIntro ease-in 1;
		animation-fill-mode:forwards;
		animation-duration:.4s;
	}
</style>



// WEBPACK FOOTER //
// src/components/summer.vue